import React, { useEffect } from 'react'
import * as DappUI from '@multiversx/sdk-dapp/UI'
import { useGetAccount, useGetIsLoggedIn } from '@multiversx/sdk-dapp/hooks/account'
import { Modal, Card, Box, Button } from '@mui/material'

import SectionTitle from '../../../../components/kit/SectionTitle'
import InfoPaper from '../../../../components/InfoPaper'
import ConnectEvmInfo from '../../../../components/ConnectEvmInfo'
import {
  storeInitiatorAddress,
  setSignXPortal,
  setExternalWallet,
} from '../../../../contexts/airdropActionCreators'
import { useAirdropDispatch, useAirdropState } from '../../../../contexts/airDropContext'
import { CloseIcon } from '../../../../assets/icons'
import './ExternalSignerOptionsModal.scss'

const ExternalSignerOptionsModal = ({
  showExternalSignerOptionsModal,
  toggleExternalSignerOptionsModal,
  initiator,
  chain,
}: {
  showExternalSignerOptionsModal: boolean
  toggleExternalSignerOptionsModal: () => void
  initiator: string
  chain: string
}) => {
  const [isFirstLoad, setIsFirstLoad] = React.useState(true)

  const isLoggedIn = useGetIsLoggedIn()
  const account = useGetAccount()
  const { signXPortal } = useAirdropState()
  const { WebWalletLoginButton } = DappUI

  const dispatchAirdropAction = useAirdropDispatch()
  const setAddress = (address: string) => {
    storeInitiatorAddress(dispatchAirdropAction, address)
    setExternalWallet(dispatchAirdropAction, true)
    // toggleExternalSignerOptionsModal();
  }

  const handleSetExternal = () => {
    setExternalWallet(dispatchAirdropAction, true)
    storeInitiatorAddress(dispatchAirdropAction, account.address)
    toggleExternalSignerOptionsModal()
  }

  const handleSignXPortal = () => {
    setSignXPortal(dispatchAirdropAction, true)
    toggleExternalSignerOptionsModal()
  }

  useEffect(() => {
    if (chain === 'multiversx' && account.address && signXPortal && !isFirstLoad) {
      setAddress(account.address)
      setExternalWallet(dispatchAirdropAction, true)
      setSignXPortal(dispatchAirdropAction, false)
    }
    setIsFirstLoad(false)
  }, [account, signXPortal])

  return (
    <Modal
      open={showExternalSignerOptionsModal}
      onClose={toggleExternalSignerOptionsModal}
      aria-labelledby="confirm-modal"
      aria-describedby="confirm-remove-modal"
      sx={{
        zIndex: 80,
      }}>
      <Card
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          minHeight: '300px',
          maxHeight: '90%',
          width: 'auto',
          maxWidth: '90%',
          background: '#181D38',
          color: '#fff',
          borderRadius: '16px',
        }}>
        <Box
          sx={{
            width: '100%',
            height: '100%',
            minHeight: '300px',
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'column',
            gap: '2rem',
            borderRadius: '8px',
            boxSizing: 'border-box',
            padding: '24px',
          }}>
          <div className="topRow">
            <div className="modalTitle">
              <SectionTitle title="Connect your wallet to sign the transactions:" />
            </div>
            <span className="closeIcon" onClick={toggleExternalSignerOptionsModal}>
              <CloseIcon />
            </span>
          </div>{' '}
          <InfoPaper infoText="Connecting a 3rd party wallet will require each transaction to be signed manually" />
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'row',
              gap: '1rem',
              flexWrap: 'wrap',
              width: '100%',
              marginBottom: '1rem',
            }}>
            {chain !== 'multiversx' ? (
              <ConnectEvmInfo
                infoText=""
                isAddressSet={Boolean(initiator)}
                setAddress={setAddress}
              />
            ) : isLoggedIn ? (
              <div className="connectMvxContainer">
                <Button className="btn btn-primary text-center" onClick={handleSetExternal}>
                  Connect wallet
                </Button>
              </div>
            ) : (
              <div className="connectMvxContainer" onClick={handleSignXPortal}>
                <WebWalletLoginButton
                  callbackRoute={window.location.pathname + window.location.search}
                  buttonClassName="btn btn-primary"
                  nativeAuth={false}>
                  <span>Connect wallet</span>
                </WebWalletLoginButton>
              </div>
            )}
          </Box>
        </Box>
      </Card>
    </Modal>
  )
}

export default ExternalSignerOptionsModal
